export default "__VITE_ASSET__CbT7dGbR__"